import BaseViewModel, { BaseViewModelParams } from "./BaseViewModel";

class SimpleAttachmentViewModel extends BaseViewModel {
	
	certificateThumbprint: string = ''
	initialFileName: string | null = null;
	isCleared: boolean = false

	constructor ( params: BaseViewModelParams ) {
		super( params );
	};

	setThumbprint = ( thumbprint: string ) => {
		this.certificateThumbprint = thumbprint;
	};

	override setValue = ( fileList: FileList | string | null ) => {
		if ( typeof fileList === "string" ) {
			this.initialFileName = fileList;
			this.isCleared = false;
			this.Value = [ new File( [], fileList ) ] as unknown as FileList;
		}
		else {
			if ( fileList === null ) {
				this.isCleared = true;
				this.Value = null;
				return;
			}
			this.isCleared = false;
			if ( fileList && fileList.length && fileList[0]?.name ) {
				this.initialFileName = fileList[0].name.replace("C:\\fakepath\\", "");
			}
			this.Value = fileList;	
		}
	};

	getCleanValue = () => {
		if ( typeof this.Value === "string" ) {
			return this.Value.replace("C:\\fakepath\\", "");
		}
		if ( !this.Value || !this.Value.length || !this.Value[0]?.name ) return '';
		return this.Value[0].name.replace("C:\\fakepath\\", "");
	};

	getInitialOrCurrentFileName = () => {
		const cur = this.getCleanValue();
		return cur || this.initialFileName || '';
	};

	getFileMaxSize = () => {
		let value: string = this.elementDescriptor.ControlKey || "";
		const regex = /\d+\s[kmg]?b/i;
		if ( value.startsWith("limit:") ) {
			const res = regex.exec(value);

			if ( res === null ) return 0;
			else value = res[0];

			const terms = value.split(' ');
			const size = parseInt(terms[0]);
			const units = terms[1].toLowerCase();
			if (units === "b")
				return size;
			else if (units === "kb")
				return size * 1024;
			else if (units === "mb")
				return size * 1024 * 1024;
			else if (units === "gb")
				return size * 1024 * 1024 * 1024;
			else
				return 0;
		}
		else return 0;
	};

	ValidateMandatory = () => {
		if ( this.isCleared ) return !this.IsMandatory;
		return !this.IsMandatory || this.getInitialOrCurrentFileName() || ( !!this.Value && !!this.Value.length );
	}

};

export default SimpleAttachmentViewModel;
